/* ==========================================================================
   About Us Page Component (Full Multi-Language Support)
   Founders Photo, Story, Dubí Case, Dual-Language Timeline, Team Accordions
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';

export function renderAboutUsPage(onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';
  const lang = getLocale() || 'en';

  const localizedStories = {
    cs: {
      eyebrow: 'O NÁS',
      heroTitle: 'Spolehlivá ochrana osob a majetku',
      heroSubtitle: 'Jsme česká technologická inovační společnost z Plzně. Jsme JALUD EMBEDDED – Jakub a Lukáš, zakladatelé s vášní pro nové technologie a jejich vývoj.',
      foundersCaption: 'Zakladatelé JALUD Embedded: Ing. Lukáš Svoboda & Ing. Jakub Vališ',
      storyEyebrow: 'NÁŠ PŘÍBĚH',
      storyP1: 'Začínali jsme specializací na komplexní tvorbu 32-bitových embedded řešení a specifických mobilních aplikací. Současně jsme tato řešení integrovali a vyvíjeli tak, aby byla nezávislá na operačním systému. Rychlý a spolehlivý vývoj softwarových aplikací nás přivedl k myšlence vytvořit produkt s pozitivním společenským dopadem.',
      storyP2: 'Náš inovativní produkt <strong>Sound Event Detector (SED)</strong> v sobě spojuje umělou inteligenci (AI) a špičkovou technologii pro detekci zvukových událostí. Je to nástroj k ochraně bezpečí všech obyvatel s ohledem na jejich soukromí a GDPR.',
      storyP3: 'SED jsou <strong>chytré uši s umělou inteligencí</strong>, které v reálném čase snímají kritické nebo nebezpečné zvuky a v případě detekce okamžitě vysílají poplach bezpečnostním složkám.',
      savedLifeTitle: 'Zachráněný lidský život v Dubí:',
      savedLifeDesc: 'Pozitivní dopad lze doložit incidentem ve městě Dubí, kde detektor SED upozornil na probíhající potyčku dvou osob. Díky poplachu z našeho detektoru byla na místo okamžitě přivolána policejní hlídka a díky rychlému zásahu a první pomoci byl zachráněn lidský život.',
      missionEyebrow: 'NAŠE MISE',
      missionP1: 'Tradiční kamerové systémy (VMS) spoléhají výhradně na obraz. Kamery však mají slepá místa, omezení za tmy, mlhy a při optických překážkách.',
      missionP2: 'Sound Event Detector (SED) doplňuje stávající bezpečnostní infrastrukturu o sluch. Během méně než 5 sekund od výstřelu, panického výkřiku, tříštění skla či příletu dronu zalarmuje hlídky a otočí PTZ kamery do směru incidentu.',
      alertLatency: 'Rychlost reakce v reálném čase',
      privacyScore: '100% ochrana soukromí dle GDPR',
      historyEyebrow: 'NAŠE HISTORIE A MILNÍKY',
      historyTitle: 'Historie společnosti JALUD',
      historySubtitle: 'Od počátků vývoje specializovaných 32-bitových embedded systémů až po mezinárodní nasazení akustické AI v chytrých městech, věznicích a kritické infrastruktuře.',
      dangerEyebrow: 'AUTOMATIZOVANÁ REAKCE NA NEBEZPEČÍ',
      dangerTitle: 'V případě nebezpečí SED okamžitě volá pomoc',
      dangerSubtitle: 'Klíčové schopnosti Sound Event Detectoru při ochraně v reálném provozu.',
      realTimeAlerts: 'Detekce v reálném čase',
      realTimeDesc: 'Upozorňuje na kritické zvukové události během méně než 5 sekund.',
      reducesTime: 'Zkracuje reakční dobu',
      reducesDesc: 'Zásadně zkracuje dojezdový čas policejních hlídek a bezpečnostních složek.',
      cctvIntegration: 'Integrace do kamerových sítí',
      cctvDesc: 'Software SED se snadno integruje do stávajících CCTV kamer a platforem VMS.',
      zeroInfra: 'Bez složité infrastruktury',
      zeroInfraDesc: 'Nevyžaduje nákladné servery; běží přímo v IP kamerách (Axis, Hanwha, Hikvision atd.) přes edge pluginy nebo na samostatných jednotkách SED.',
      teamTitle: 'Lidé za JALUD Embedded',
      teamEyebrow: 'NÁŠ TÝM A VEDENÍ',
      linkedinBtn: 'Profil na LinkedInu →'
    },
    en: {
      eyebrow: 'ABOUT US',
      heroTitle: 'Reliable Protection for People and Property',
      heroSubtitle: 'We are a Czech technological innovation company from Pilsen. We are JALUD EMBEDDED – Jakub and Lukáš, founders with a passion for new technologies and their development.',
      foundersCaption: 'JALUD Embedded Founders: Lukáš Svoboda & Jakub Vališ',
      storyEyebrow: 'OUR STORY',
      storyP1: 'We started by specializing in the complex creation of 32-bit Embedded solutions and specific mobile applications. At the same time, we integrated and developed these solutions to be operating system independent. Our fast and reliable software application development led us to the idea of inventing a product that would span multiple domains and have a positive social impact.',
      storyP2: 'Our innovative <strong>Sound Event Detector (SED)</strong> product incorporates artificial intelligence (AI) and state-of-the-art technology for audio event detection. It is a tool to protect the safety of all residents with regards to their GDPR. It is also a tool that can be used for property security.',
      storyP3: 'SEDs are <strong>AI-powered smart ears</strong> that sense critical or dangerous sounds in real-time, and if they detect these sounds, they immediately send an alert to security forces.',
      savedLifeTitle: 'Life Saved in Dubí:',
      savedLifeDesc: 'A positive impact can be cited in an incident that took place in the city of Dubí, where an SED alerted to a fight in progress between two people. Thanks to the alert from our AI-driven sound detector, the police were called to the scene of the fight, and thanks to the quick intervention and subsequent first aid, a human life was saved.',
      missionEyebrow: 'OUR MISSION',
      missionP1: 'Traditional Video Management Systems (VMS) rely entirely on vision. However, visual cameras have inherent blind spots, darkness limitations, and optical obstructions.',
      missionP2: 'Sound Event Detector (SED) equips existing security infrastructure with real-time acoustic intelligence. Within <5s of a gunshot report, panic scream, glass break, or approaching drone, SED alerts police patrols and automatically turns PTZ cameras directly toward the incident.',
      alertLatency: 'Instant Alert Latency',
      privacyScore: 'GDPR Non-Invasive Privacy',
      historyEyebrow: 'OUR MILESTONES & JOURNEY',
      historyTitle: "JALUD's History",
      historySubtitle: 'From initial 32-bit embedded systems development to international AI acoustic security deployment across smart cities, prisons, healthcare facilities, and critical infrastructure.',
      dangerEyebrow: 'AUTOMATED EMERGENCY RESPONSE',
      dangerTitle: 'In Case of Danger, SED Immediately Calls for Help',
      dangerSubtitle: 'Key operational capabilities of Sound Event Detector in active field protection.',
      realTimeAlerts: 'Real-Time Event Alerts',
      realTimeDesc: 'Alerts in real time to critical acoustic sound events in under 5 seconds.',
      reducesTime: 'Reduces Response Time',
      reducesDesc: 'Dramatically reduces arrival time of police patrols and emergency security forces.',
      cctvIntegration: 'CCTV System Integration',
      cctvDesc: 'SED software integrates seamlessly into existing CCTV networks and VMS platforms.',
      zeroInfra: 'Zero Heavy Infrastructure',
      zeroInfraDesc: 'Does not require complex technical server infrastructure; runs natively on leading IP cameras (Axis, Hanwha, Hikvision, etc.) via edge plugins or on standalone SED units.',
      teamTitle: 'Leadership & Engineering Team',
      teamEyebrow: 'MEET THE LEADERSHIP TEAM',
      linkedinBtn: 'LinkedIn Profile →'
    },
    de: {
      eyebrow: 'ÜBER UNS',
      heroTitle: 'Zuverlässiger Schutz von Personen und Eigentum',
      heroSubtitle: 'Wir sind ein europäisches Deep-Tech-Unternehmen aus Pilsen. JALUD EMBEDDED – Gegründet von Jakub und Lukáš mit Leidenschaft für akustische KI-Innovationen.',
      foundersCaption: 'JALUD Embedded Gründer: Lukáš Svoboda & Jakub Vališ',
      storyEyebrow: 'UNSERE GESCHICHTE',
      storyP1: 'Wir begannen mit der Entwicklung von 32-Bit-Embedded-Systemen und mobilen Anwendungen. Die Leidenschaft für zuverlässige Softwareentwicklung brachte uns auf die Idee, ein Produkt mit großem gesellschaftlichem Nutzen zu entwickeln.',
      storyP2: 'Unser <strong>Sound Event Detector (SED)</strong> kombiniert künstliche Intelligenz mit modernster akustischer Mustererkennung zum Schutz der öffentlichen Sicherheit bei 100% DSGVO-Konformität.',
      storyP3: 'SED sind <strong>intelligente KI-Ohren</strong>, die Gefahrenschall in Echtzeit analysieren und Einsatzkräfte sofort alarmieren.',
      savedLifeTitle: 'Gerettetes Menschenleben in Dubí:',
      savedLifeDesc: 'In der Stadt Dubí erkannte SED eine gewalttätige Auseinandersetzung. Dank des Sofortalarms traf die Polizei innerhalb weniger Minuten ein und konnte durch Erste Hilfe ein Leben retten.',
      missionEyebrow: 'UNSERE MISSION',
      missionP1: 'Klassische Videoüberwachung hat tote Winkel bei Dunkelheit, Nebel und Hindernissen.',
      missionP2: 'Sound Event Detector stattet Sicherheitskameras mit Gehör aus. Innerhalb von <5s schwenken PTZ-Kameras auf Schüsse, Schreie oder Glasbruch.',
      alertLatency: 'Echtzeit-Warnlatenz',
      privacyScore: 'DSGVO-Datenschutz',
      historyEyebrow: 'MEILENSTEINE & ENTWICKLUNG',
      historyTitle: 'JALUDs Geschichte',
      historySubtitle: 'Von der Entwicklung spezialisierter 32-Bit-Embedded-Systeme bis zum internationalen Einsatz akustischer KI in Smart Cities und kritischer Infrastruktur.',
      dangerEyebrow: 'AUTOMATISIERTE GEFAHRENREAKTION',
      dangerTitle: 'Im Ernstfall ruft SED sofort Hilfe',
      dangerSubtitle: 'Wichtigste operative Schutzfunktionen von Sound Event Detector.',
      realTimeAlerts: 'Echtzeit-Erkennung',
      realTimeDesc: 'Warnt bei kritischen Schallereignissen in weniger als 5 Sekunden.',
      reducesTime: 'Verkürzt Reaktionszeit',
      reducesDesc: 'Reduziert die Anfahrtszeit von Einsatzkräften und Streifen maßgeblich.',
      cctvIntegration: 'Nahtlose VMS-Integration',
      cctvDesc: 'Integriert sich nativ in bestehende Axis-, Hanwha- und Milestone-Netzwerke.',
      zeroInfra: 'Keine Server-Infrastruktur',
      zeroInfraDesc: 'Läuft direkt auf führenden IP-Kameras oder kompakten SED-Boxen.',
      teamTitle: 'Führungsteam & F&E-Ingenieure',
      teamEyebrow: 'UNSER TEAM',
      linkedinBtn: 'LinkedIn Profil →'
    },
    es: {
      eyebrow: 'SOBRE NOSOTROS',
      heroTitle: 'Protección confiable de personas y bienes',
      heroSubtitle: 'Somos una empresa europea de innovación tecnológica con sede en Pilsen. JALUD EMBEDDED – fundada por Jakub y Lukáš con pasión por la inteligencia acústica.',
      foundersCaption: 'Fundadores de JALUD Embedded: Lukáš Svoboda y Jakub Vališ',
      storyEyebrow: 'NUESTRA HISTORIA',
      storyP1: 'Comenzamos especializándonos en sistemas embebidos de 32 bits y aplicaciones móviles de alto rendimiento. Esa experiencia nos impulsó a crear una solución con impacto humano y social.',
      storyP2: 'Nuestro <strong>Sound Event Detector (SED)</strong> combina IA con procesamiento acústico avanzado para proteger espacios públicos respetando el GDPR.',
      storyP3: 'Los detectores SED son <strong>oídos inteligentes impulsados por IA</strong> que alertan al instante sobre sonidos de peligro en tiempo real.',
      savedLifeTitle: 'Vida salvada en Dubí:',
      savedLifeDesc: 'En la ciudad de Dubí, el detector SED alertó sobre una agresión física en curso. La rápida llegada de la patrulla policial permitió prestar primeros auxilios y salvar una vida.',
      missionEyebrow: 'NUESTRA MISIÓN',
      missionP1: 'Los sistemas de videovigilancia tradicionales dependen de la línea de visión y tienen puntos ciegos.',
      missionP2: 'SED dota a las cámaras de audición inteligente. En menos de 5 segundos tras un disparo, grito o rotura de cristal, alerta a los agentes y orienta las cámaras PTZ.',
      alertLatency: 'Latencia de alerta instantánea',
      privacyScore: 'Cumplimiento GDPR y privacidad',
      historyEyebrow: 'HITOS Y TRAYECTORIA',
      historyTitle: 'Historia de JALUD',
      historySubtitle: 'Desde el desarrollo inicial de sistemas embebidos de 32 bits hasta el despliegue internacional de IA acústica en ciudades inteligentes e infraestructuras críticas.',
      dangerEyebrow: 'RESPUESTA AUTOMATIZADA A EMERGENCIAS',
      dangerTitle: 'En caso de peligro, SED solicita ayuda de inmediato',
      dangerSubtitle: 'Capacidades operativas clave de Sound Event Detector.',
      realTimeAlerts: 'Detección en tiempo real',
      realTimeDesc: 'Alerta sobre eventos sonoros críticos en menos de 5 segundos.',
      reducesTime: 'Reduce tiempos de respuesta',
      reducesDesc: 'Acorta drásticamente el tiempo de llegada de la policía y guardias de seguridad.',
      cctvIntegration: 'Integración en redes CCTV',
      cctvDesc: 'Se integra fácilmente en plataformas VMS como Milestone, Axis y Genetec.',
      zeroInfra: 'Cero infraestructura pesada',
      zeroInfraDesc: 'Ejecución en cámaras IP líderes (Axis, Hanwha, Hikvision) o unidades SED autónomas.',
      teamTitle: 'Equipo Directivo e Ingeniería de I+D',
      teamEyebrow: 'NUESTRO EQUIPO',
      linkedinBtn: 'Perfil de LinkedIn →'
    },
    pt: {
      eyebrow: 'SOBRE NÓS',
      heroTitle: 'Proteção confiável de pessoas e patrimônio',
      heroSubtitle: 'Somos uma empresa europeia de inovação tecnológica com sede em Pilsen. JALUD EMBEDDED – fundada por Jakub e Lukáš com paixão pela inteligência acústica.',
      foundersCaption: 'Fundadores da JALUD Embedded: Lukáš Svoboda e Jakub Vališ',
      storyEyebrow: 'NOSSA HISTÓRIA',
      storyP1: 'Começamos nos especializando na criação de sistemas embarcados de 32 bits e aplicações móveis de alto desempenho. Essa experiência nos impulsionou a criar uma solução com grande impacto humano e social.',
      storyP2: 'Nosso inovador <strong>Sound Event Detector (SED)</strong> combina inteligência artificial com processamento acústico avançado para proteger espaços públicos respeitando o GDPR.',
      storyP3: 'Os detectores SED são <strong>ouvidos inteligentes com IA</strong> que alertam instantaneamente as forças de segurança sobre sons de perigo em tempo real.',
      savedLifeTitle: 'Vida salva em Dubí:',
      savedLifeDesc: 'Na cidade de Dubí, o detector SED alertou sobre uma agressão física em andamento. A rápida chegada da patrulha policial permitiu prestar os primeiros socorros e salvar uma vida humana.',
      missionEyebrow: 'NOSSA MISSÃO',
      missionP1: 'Os sistemas de videovigilância tradicionais dependem da linha de visão e possuem pontos cegos no escuro ou em neblina.',
      missionP2: 'O SED equipa as câmeras com audição inteligente. Em menos de 5 segundos após um disparo, grito ou vidro quebrado, alerta os agentes e orienta as câmeras PTZ.',
      alertLatency: 'Latência de alerta instantâneo',
      privacyScore: 'Conformidade GDPR e privacidade',
      historyEyebrow: 'HISTÓRIA E MARCOS',
      historyTitle: 'História da JALUD',
      historySubtitle: 'Desde o desenvolvimento inicial de sistemas embarcados até a implantação internacional de IA acústica em cidades inteligentes e infraestruturas críticas.',
      dangerEyebrow: 'RESPOSTA AUTOMATIZADA A EMERGÊNCIAS',
      dangerTitle: 'Em caso de perigo, o SED solicita ajuda imediatamente',
      dangerSubtitle: 'Principais recursos operacionais do Sound Event Detector em proteção ativa.',
      realTimeAlerts: 'Detecção em tempo real',
      realTimeDesc: 'Alerta sobre eventos sonoros críticos em menos de 5 segundos.',
      reducesTime: 'Reduz o tempo de resposta',
      reducesDesc: 'Reduz drasticamente o tempo de chegada das patrulhas policiais e socorristas.',
      cctvIntegration: 'Integração com redes CFTV',
      cctvDesc: 'Integra-se facilmente a plataformas VMS líderes como Milestone, Axis e Genetec.',
      zeroInfra: 'Zero infraestrutura pesada',
      zeroInfraDesc: 'Executa diretamente em câmeras IP líderes (Axis, Hanwha, Hikvision) ou unidades SED autônomas.',
      teamTitle: 'Equipe de Liderança e Engenharia de P&D',
      teamEyebrow: 'NOSSA EQUIPE',
      linkedinBtn: 'Perfil no LinkedIn →'
    },
    ar: {
      eyebrow: 'من نحن',
      heroTitle: 'حماية موثوقة للأرواح والممتلكات',
      heroSubtitle: 'نحن شركة تكنولوجية مبتكرة من بلزن. JALUD EMBEDDED – أسسها يعقوب ولوكاش بشغف لتطوير الذكاء الاصطناعي الصوتي.',
      foundersCaption: 'مؤسسو JALUD Embedded: لوكاش سفوبودا ويعقوب فاليش',
      storyEyebrow: 'قصتنا',
      storyP1: 'بدأنا بالتخصص في تطوير الأنظمة المدمجة 32-بت والتطبيقات البرمجية المتقدمة. قادتنا الرغبة في إحداث تأثير إيجابي في المجتمع لابتكار حل ينقذ الأرواح.',
      storyP2: 'يجمع منتجنا المبتكر <strong>Sound Event Detector (SED)</strong> بين الذكاء الاصطناعي وأحدث تقنيات المعالجة الصوتية لحماية الأرواح والممتلكات مع الامتثال الكامل لقوانين الخصوصية GDPR.',
      storyP3: 'أجهزة SED هي <strong>آذان ذكية مدعومة بالذكاء الاصطناعي</strong> تلتقط أصوات الخطر في الوقت الفعلي وترسل تنبيهات فورية لقوات الأمن.',
      savedLifeTitle: 'إنقاذ حياة إنسان في دوبي:',
      savedLifeDesc: 'في مدينة دوبي، اكتشف نظام SED شجاراً عنيفاً وأرسل إنذاراً فورياً. بفضل وصول دورية الشرطة السريع والإسعافات الأولية، تم إنقاذ حياة إنسان.',
      missionEyebrow: 'مهمتنا',
      missionP1: 'تعتمد كاميرات المراقبة التقليدية على الرؤية البصرية فقط، ولديها نقاط عمياء في الظلام والضباب.',
      missionP2: 'يمنح SED الكاميرات حاسة السمع الذكي. في أقل من 5 ثوانٍ من إطلاق نار أو صرخة ذعر أو كسر زجاج، ينبه الشرطة ويوجه كاميرات PTZ نحو مصدر الصوت.',
      alertLatency: 'سرعة الاستجابة اللحظية',
      privacyScore: 'حماية الخصوصية GDPR',
      historyEyebrow: 'تاريخنا ومحطات النجاح',
      historyTitle: 'تاريخ شركة JALUD',
      historySubtitle: 'من البدايات الأولى في تطوير الأنظمة المدمجة إلى الانتشار الدولي للذكاء الاصطناعي الصوتي في المدن الذكية والبنية التحتية الحيوية.',
      dangerEyebrow: 'استجابة آلية فورية لحالات الطوارئ',
      dangerTitle: 'في حالات الخطر، يطلب SED المساعدة فوراً',
      dangerSubtitle: 'القدرات التشغيلية لنظام كاشف الأحداث الصوتية في الميدان.',
      realTimeAlerts: 'كشف فوري في الوقت الفعلي',
      realTimeDesc: 'تنبيه فوري للأحداث الصوتية الخطيرة في أقل من 5 ثوانٍ.',
      reducesTime: 'تقليص زمن الاستجابة',
      reducesDesc: 'يقلل بشكل جذري من وقت وصول دوريات الشرطة وفرق الطوارئ.',
      cctvIntegration: 'تكامل سلس مع شبكات CCTV',
      cctvDesc: 'يتكامل بسهولة مع كاميرات المراقبة وأنظمة VMS الرائدة مثل Milestone وAxis.',
      zeroInfra: 'بدون بنية تحتية معقدة',
      zeroInfraDesc: 'يعمل مباشرة على كاميرات IP أو وحدات SED المستقلة دون الحاجة لخوادم إضافية.',
      teamTitle: 'فريق القيادة وهندسة البحث والتطوير',
      teamEyebrow: 'فريق العمل',
      linkedinBtn: 'الملف الشخصي على LinkedIn ←'
    }
  };

  const text = localizedStories[lang] || localizedStories['en'];

  const teamUi = {
    en: { motto: 'Motto', likeSed: 'What I like about SED', whyJalud: 'Why JALUD' },
    cs: { motto: 'Moje motto', likeSed: 'Co se mi líbí na SED', whyJalud: 'Proč JALUD' },
    de: { motto: 'Motto', likeSed: 'Was mir an SED gefällt', whyJalud: 'Warum JALUD' },
    es: { motto: 'Lema', likeSed: 'Lo que me gusta de SED', whyJalud: 'Por qué JALUD' },
    pt: { motto: 'Lema', likeSed: 'O que gosto no SED', whyJalud: 'Por que a JALUD' },
    ar: { motto: 'الشعار', likeSed: 'ما يعجبني في SED', whyJalud: 'لماذا JALUD' }
  };
  const tUi = teamUi[lang] || teamUi.en;

  const teamMembers = [
    {
      name: "Lukáš",
      fullName: "Lukáš Svoboda",
      title: lang === 'cs' ? "Výkonný ředitel (CEO) & Spoluzakladatel" : "CEO & Co-Founder",
      img: "/images/Lukas_Svoboda.png",
      motto: lang === 'cs' ? "Nedělejte si starosti, pokud věci nefungují správně napoprvé. Kdyby vše fungovalo samo, nebyli bychom potřeba." : "Don’t worry if it doesn’t work right. If everything did, you’d be out of a job.",
      likeAboutSED: lang === 'cs' ? "Slouží dobrému účelu – produkt nijak nezasahuje do soukromí občanů a zásadně urychluje zásah záchranných složek." : "It serves for a good purpose, the product does not infringe our privacy and brings faster emergency response.",
      whyJalud: lang === 'cs' ? "Vytvořili jsme produkt, který je nejen technologicky špičkový, ale pomáhá dělat svět bezpečnějším místem!" : "We have created a product that is not only innovative but also helps the world to be a safer place!",
      linkedin: "https://www.linkedin.com/in/lucas-svoboda/"
    },
    {
      name: "Jakub",
      fullName: "Jakub Vališ",
      title: lang === 'cs' ? "Technický ředitel (CTO) & Spoluzakladatel" : "CTO & Co-Founder",
      img: "/images/Jakub_Valis.png",
      motto: lang === 'cs' ? "Nikdy neříkej, že něco nelze vyrobit – vždy se najde někdo, kdo to neví, a vyrobí to." : "Never say something is impossible to make or there comes a fool who doesn’t know it is impossible to make and makes it.",
      likeAboutSED: lang === 'cs' ? "Zhoršující se bezpečnostní situace nutí lidi vzdávat se soukromí. SED dává možnost zvýšit bezpečí bez ztráty soukromí." : "The deteriorating security situation in the world is forcing people to give up their privacy. SED gives an option to increase public security without losing privacy.",
      whyJalud: lang === 'cs' ? "Vždy bylo mým snem vybudovat technologickou firmu zaměřenou na vývoj inovativních produktů." : "It has been always my dream to found a company that is focused on innovative product.",
      linkedin: "https://www.linkedin.com/in/jakub-vali%C5%A1-9a459578/"
    },
    {
      name: "Dominika",
      fullName: "Dominika Petr",
      title: lang === 'cs' ? "Marketingová specialistka" : "Marketing Specialist",
      img: "/images/Dominika_Pekova.png",
      motto: lang === 'cs' ? "Dělej to, co tě naplňuje a dělá šťastným." : "Do what makes you happy.",
      likeAboutSED: lang === 'cs' ? "Téměř neviditelná technologie, která dokáže zachránit lidský život." : "An almost invisible thing that can save a life.",
      whyJalud: lang === 'cs' ? "Smysluplný produkt s reálným pozitivním dopadem a skvělý tým lidí." : "A product that has a positive impact and a great team of people behind it.",
      linkedin: "https://www.linkedin.com/in/dominika-petr/"
    },
    {
      name: "Kateřina",
      fullName: "Kateřina Vlčková",
      title: lang === 'cs' ? "Vedoucí administrativy" : "Administrative Manager",
      img: "/images/Katerina.jpeg",
      motto: lang === 'cs' ? "Být šťastný neznamená, že je vše dokonalé, ale rozhodnutí užívat si život i s jeho nedokonalostmi." : "Being happy doesn’t mean everything is perfect. It means you choose to enjoy life despite all its imperfections.",
      likeAboutSED: lang === 'cs' ? "Líbí se mi, že pomáhá dělat svět bezpečnějším – malá věc, která přináší velký rozdíl při záchraně životů." : "I love that it makes the world a safer place. A small thing that can make a big difference in saving lives.",
      whyJalud: lang === 'cs' ? "Je skvělé podílet se na práci v týmu, který vyvíjí produkt měnící svět k lepšímu." : "It’s great to be able to participate in JALUD’s work on a product that has the potential to change the world into a better place.",
      linkedin: "https://www.linkedin.com/company/jalud-embedded/"
    },
    {
      name: "Martin",
      fullName: "Martin Šimek",
      title: lang === 'cs' ? "Hlavní vývojář software" : "Senior Software Developer",
      img: "/images/Martin.jpg",
      motto: lang === 'cs' ? "Věci se dají dělat buď jednoduše a správně, nebo vůbec." : "It can be done easily or not at all.",
      likeAboutSED: lang === 'cs' ? "Skvělý IoT projekt kombinující fyzický embedded hardware a cloudový backend." : "It is IoT project with both Devices and Backend.",
      whyJalud: lang === 'cs' ? "Inovativní firma s chutí dělat moderní software na špičkové úrovni." : "It is a tech company with the will to do software the right way.",
      linkedin: "https://www.linkedin.com/in/martin-%C5%A1imek-1793ab10/"
    },
    {
      name: "Martina",
      fullName: "Martina Zapletalová",
      title: lang === 'cs' ? "Marketingová manažerka" : "Marketing Manager",
      img: "/images/Martina.jpeg",
      motto: lang === 'cs' ? "Život je jako bonboniéra – nikdy nevíš, co ochutnáš." : "Life is like a box of chocolates — you never know what you’re going to get.",
      likeAboutSED: lang === 'cs' ? "Diskrétní pomocník, který na sebe nepoutá pozornost, ale v pravý okamžik chrání a zajistí bezpečí." : "It’s exactly the kind of discreet helper that doesn’t ask for attention, yet in the right moment can protect, save, and ensure safety.",
      whyJalud: lang === 'cs' ? "Jalud tvoří skvělý tým profesionálů, jejichž práce má skutečný dopad na prevenci a ochranu bezpečí." : "Jalud is made up of a great team of people who understand what they do, and their work has a real impact.",
      linkedin: "https://www.linkedin.com/in/martina-zapletalov%C3%A1-44700b97/"
    },
    {
      name: "Zuzana",
      fullName: "Zuzana Medová",
      title: lang === 'cs' ? "Administrativní manažerka" : "Administrative Manager",
      img: "/images/Zuzana.png",
      motto: lang === 'cs' ? "Zachovej klid a s úsměvem dál." : "Stay calm, smile on.",
      likeAboutSED: lang === 'cs' ? "Zvyšuje bezpečnost a dokáže zachraňovat lidské životy bleskovou reakcí na krizové události." : "I like that it improves safety and it can save lives by quick response to critical events.",
      whyJalud: lang === 'cs' ? "Možnost pracovat na smysluplných inovacích, které mají pozitivní společenský přínos." : "It’s great to be able to participate in JALUD’s work on a product that has the potential to change the world into a better place.",
      linkedin: "https://www.linkedin.com/in/zuzana-medov%C3%A1-431855165/"
    },
    {
      name: "Libor",
      fullName: "Libor Novák",
      title: lang === 'cs' ? "Vedoucí M&A a strategického rozvoje" : "Mergers & Acquisitions Lead",
      img: "/images/Libor_Novak.png",
      motto: lang === 'cs' ? "Strategický růst prostřednictvím globálních partnerství a technologických inovací." : "Strategic growth through global partnership and innovation.",
      likeAboutSED: lang === 'cs' ? "Expanze systému SED na mezinárodní bezpečnostní trhy v Evropě, Americe a Asii." : "Expanding SED into international security markets across Europe, America, and Asia.",
      whyJalud: lang === 'cs' ? "Vysoký růstový potenciál podpořený unikátní patentovanou technologií akustické AI." : "High-growth potential backed by unique, patented acoustic AI technology.",
      linkedin: "https://www.linkedin.com/in/libor-novak-a7878411/"
    }
  ];

  const timelineImage = lang === 'cs' ? '/images/historie-jaludu-cz.png' : '/images/historie-jaludu-en.png';

  container.innerHTML = `
    <!-- Company Hero -->
    <section class="sed-section" style="background: linear-gradient(165deg, var(--navy-dark) 0%, var(--blue-dark) 100%); color: #ffffff; padding: 4.5rem 0 3.5rem;">
      <div class="sed-container">
        <div class="sed-detail-hero-grid">
          <div>
            <div class="sed-eyebrow" style="background: rgba(255,255,255,0.1); color: var(--blue-primary); border-color: rgba(255,255,255,0.2);">${text.eyebrow}</div>
            <h1 class="sed-page-hero-title">
              ${text.heroTitle}
            </h1>
            <p style="font-size: 1.15rem; color: #e2e8f0; line-height: 1.65; margin-bottom: 2rem;">
              ${text.heroSubtitle}
            </p>
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
              <a href="#contact" class="sed-btn sed-btn-hero sed-btn-primary" data-route="contact">${t('common.applyContact')}</a>
              <a href="#solutions" class="sed-btn sed-btn-hero" style="background: transparent; color: #ffffff; border: 1.5px solid rgba(255,255,255,0.35); text-decoration: none;" data-route="solutions">${t('home.exploreSolutions')}</a>
            </div>
          </div>
          <div style="border-radius: var(--radius-card); overflow: hidden; border: 2px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.05); padding: 1.25rem; text-align: center; box-shadow: 0 20px 50px rgba(0,0,0,0.3);">
            <picture>
              <source srcset="/images/zakladatele-valis-svoboda-mobile.jpg" media="(max-width: 768px)">
              <img src="/images/zakladatele-valis-svoboda-opt.jpg" alt="Zakladatelé JALUD Embedded" width="600" height="400" loading="eager" fetchpriority="high" style="width: 100%; max-height: 340px; object-fit: cover; object-position: 65% center; border-radius: 8px;">
            </picture>
            <div style="font-size: 0.88rem; color: #cbd5e1; margin-top: 0.85rem; font-weight: 600;">${text.foundersCaption}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Story & Mission Section -->
    <section class="sed-section" style="background-color: #ffffff;">
      <div class="sed-container">
        <div class="sed-2col-grid">
          
          <!-- Left Column: OUR STORY -->
          <div>
            <div class="sed-eyebrow" style="margin-bottom: 1.25rem;">${text.storyEyebrow}</div>
            <p style="font-size: 1.05rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.25rem;">
              ${text.storyP1}
            </p>
            <p style="font-size: 1.05rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.25rem;">
              ${text.storyP2}
            </p>
            <p style="font-size: 1.05rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.25rem;">
              ${text.storyP3}
            </p>

            <div style="background-color: var(--blue-ultra-light); border-left: 4px solid var(--blue-primary); padding: 1.25rem 1.5rem; border-radius: 0 12px 12px 0; margin-top: 1.5rem; border: 1px solid var(--blue-light); border-left-width: 4px;">
              <strong style="color: var(--navy-dark); display: block; font-size: 1.05rem; margin-bottom: 0.4rem;">
                ${text.savedLifeTitle}
              </strong>
              <span style="color: var(--text-dark); font-size: 0.98rem; line-height: 1.6;">
                ${text.savedLifeDesc}
              </span>
            </div>
          </div>

          <!-- Right Column: OUR MISSION -->
          <div>
            <div class="sed-eyebrow" style="margin-bottom: 1.25rem;">${text.missionEyebrow}</div>
            <p style="font-size: 1.05rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.25rem;">
              ${text.missionP1}
            </p>
            <p style="font-size: 1.05rem; color: var(--text-dark); line-height: 1.75; margin-bottom: 1.75rem;">
              ${text.missionP2}
            </p>

            <div class="sed-2col-grid" style="border-top: 1px solid var(--slate-line); padding-top: 1.5rem; gap: 1.5rem;">
              <div style="background: var(--blue-ultra-light); padding: 1.25rem; border-radius: 12px; border: 1px solid var(--blue-light);">
                <div style="font-size: 2.2rem; font-weight: 800; color: var(--blue-primary); line-height: 1;">&lt;5s</div>
                <div style="font-size: 0.88rem; font-weight: 700; color: var(--navy-dark); margin-top: 0.5rem; line-height: 1.35;">
                  ${text.alertLatency}
                </div>
              </div>
              <div style="background: var(--blue-ultra-light); padding: 1.25rem; border-radius: 12px; border: 1px solid var(--blue-light);">
                <div style="font-size: 2.2rem; font-weight: 800; color: var(--blue-primary); line-height: 1;">100%</div>
                <div style="font-size: 0.88rem; font-weight: 700; color: var(--navy-dark); margin-top: 0.5rem; line-height: 1.35;">
                  ${text.privacyScore}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- JALUD's History Timeline Section -->
    <section class="sed-section" style="background-color: var(--blue-ultra-light); border-top: 1px solid var(--slate-line); border-bottom: 1px solid var(--slate-line);">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 800px; margin: 0 auto 2.5rem; text-align: center;">
          <div class="sed-eyebrow">${text.historyEyebrow}</div>
          <h2 class="sed-section-title">${text.historyTitle}</h2>
          <p class="sed-section-desc">${text.historySubtitle}</p>
        </div>

        <div style="background: #ffffff; border: 1px solid var(--slate-line); border-radius: var(--radius-card); padding: 1.5rem; box-shadow: var(--shadow-sm); display: flex; justify-content: center; align-items: center;">
          <img src="${timelineImage}" alt="${text.historyTitle}" style="width: 100%; max-width: 1100px; height: auto; border-radius: 8px; display: block;">
        </div>
      </div>
    </section>

    <!-- In Case of Danger Capabilities Section (Unified Blue SVG Icons) -->
    <section class="sed-section" style="background-color: #ffffff;">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 800px;">
          <div class="sed-eyebrow">${text.dangerEyebrow}</div>
          <h2 class="sed-section-title">${text.dangerTitle}</h2>
          <p class="sed-section-desc">${text.dangerSubtitle}</p>
        </div>

        <div class="sed-grid-4">
          <div class="sed-card" style="border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 1.75rem;">
            <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--blue-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
            </div>
            <h3 class="sed-card-title">${text.realTimeAlerts}</h3>
            <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0;">${text.realTimeDesc}</p>
          </div>

          <div class="sed-card" style="border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 1.75rem;">
            <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--blue-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
            </div>
            <h3 class="sed-card-title">${text.reducesTime}</h3>
            <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0;">${text.reducesDesc}</p>
          </div>

          <div class="sed-card" style="border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 1.75rem;">
            <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--blue-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 8-6 4 6 4V8Z"></path><rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect></svg>
            </div>
            <h3 class="sed-card-title">${text.cctvIntegration}</h3>
            <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0;">${text.cctvDesc}</p>
          </div>

          <div class="sed-card" style="border: 1.5px solid var(--slate-line); border-radius: 14px; padding: 1.75rem;">
            <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--blue-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M9 3v18"></path><path d="M15 3v18"></path><path d="M3 9h18"></path><path d="M3 15h18"></path></svg>
            </div>
            <h3 class="sed-card-title">${text.zeroInfra}</h3>
            <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0;">${text.zeroInfraDesc}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Team Members Section -->
    <section class="sed-section" style="background-color: var(--blue-ultra-light); border-top: 1px solid var(--slate-line);">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 800px; margin-bottom: 2.5rem;">
          <div class="sed-eyebrow">${text.teamEyebrow || "MEET THE TEAM"}</div>
          <h2 class="sed-section-title">${text.teamTitle}</h2>
        </div>

        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 1.5rem; align-items: stretch;">
          ${teamMembers.map(m => `
            <div class="sed-card" style="padding: 1.5rem 1.25rem; display: flex; flex-direction: column; justify-content: space-between; border-radius: 14px; background: #ffffff; border: 1.5px solid var(--slate-line); box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s ease, box-shadow 0.2s ease;" onmouseover="this.style.transform='translateY(-3px)'; this.style.boxShadow='0 10px 24px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';">
              <div>
                <!-- Member Photo -->
                <div style="text-align: center; margin-bottom: 0.85rem;">
                  <img src="${m.img}" alt="${m.fullName}" style="width: 88px; height: 88px; border-radius: 50%; object-fit: cover; object-position: center top; border: 3px solid #0284c7; box-shadow: 0 4px 12px rgba(2, 132, 199, 0.18);">
                </div>

                <!-- Name & Title -->
                <div style="text-align: center; margin-bottom: 1rem;">
                  <h3 style="font-size: 1.15rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.25rem;">${m.fullName}</h3>
                  <div style="font-size: 0.82rem; font-weight: 700; color: #0284c7;">${m.title}</div>
                </div>

                <!-- Section: Motto (Clickable / Collapsible) -->
                <details class="sed-team-toggle" style="margin-bottom: 0.5rem; border-top: 1px solid #f1f5f9; padding-top: 0.5rem;">
                  <summary style="font-size: 0.82rem; font-weight: 800; color: #0284c7; cursor: pointer; display: flex; align-items: center; justify-content: space-between; list-style: none; user-select: none; padding: 0.15rem 0;">
                    <span style="display: flex; align-items: center; gap: 5px;">
                      <span class="sed-team-toggle-arrow" style="font-size: 0.68rem; transition: transform 0.2s ease;">▲</span> ${tUi.motto}
                    </span>
                  </summary>
                  <div style="padding: 0.35rem 0 0.15rem; font-size: 0.82rem; color: var(--text-dark); line-height: 1.45;">
                    ${m.motto}
                  </div>
                </details>

                <!-- Section: What I like about SED (Clickable / Collapsible) -->
                <details class="sed-team-toggle" style="margin-bottom: 0.5rem; border-top: 1px solid #f1f5f9; padding-top: 0.5rem;">
                  <summary style="font-size: 0.82rem; font-weight: 800; color: #0284c7; cursor: pointer; display: flex; align-items: center; justify-content: space-between; list-style: none; user-select: none; padding: 0.15rem 0;">
                    <span style="display: flex; align-items: center; gap: 5px;">
                      <span class="sed-team-toggle-arrow" style="font-size: 0.68rem; transition: transform 0.2s ease;">▲</span> ${tUi.likeSed}
                    </span>
                  </summary>
                  <div style="padding: 0.35rem 0 0.15rem; font-size: 0.82rem; color: var(--text-dark); line-height: 1.45;">
                    ${m.likeAboutSED}
                  </div>
                </details>

                <!-- Section: Why JALUD (Clickable / Collapsible) -->
                <details class="sed-team-toggle" style="margin-bottom: 0.5rem; border-top: 1px solid #f1f5f9; padding-top: 0.5rem;">
                  <summary style="font-size: 0.82rem; font-weight: 800; color: #0284c7; cursor: pointer; display: flex; align-items: center; justify-content: space-between; list-style: none; user-select: none; padding: 0.15rem 0;">
                    <span style="display: flex; align-items: center; gap: 5px;">
                      <span class="sed-team-toggle-arrow" style="font-size: 0.68rem; transition: transform 0.2s ease;">▲</span> ${tUi.whyJalud}
                    </span>
                  </summary>
                  <div style="padding: 0.35rem 0 0.15rem; font-size: 0.82rem; color: var(--text-dark); line-height: 1.45;">
                    ${m.whyJalud}
                  </div>
                </details>
              </div>

              <!-- LinkedIn Link -->
              <div style="text-align: center; border-top: 1px solid #f1f5f9; padding-top: 0.85rem; margin-top: auto;">
                <a href="${m.linkedin}" target="_blank" rel="noopener noreferrer" style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 6px 14px; border-radius: 6px; background-color: #f0f7fc; color: #0077b5; font-weight: 800; font-size: 0.82rem; text-decoration: none; transition: all 0.2s ease; border: 1px solid #d0e7f7; width: 100%;" onmouseover="this.style.backgroundColor='#0077b5'; this.style.color='#ffffff';" onmouseout="this.style.backgroundColor='#f0f7fc'; this.style.color='#0077b5';" aria-label="${m.fullName} LinkedIn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.46 10.9v8.37H9.2V10.9H6.46M7.83 6.64c-.9 0-1.63.73-1.63 1.63s.73 1.63 1.63 1.63 1.63-.73 1.63-1.63-.73-1.63-1.63-1.63Z"/></svg>
                  <span>${text.linkedinBtn}</span>
                </a>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    </section>
  `;

  // Attach SPA Navigation Handlers
  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = link.getAttribute('data-route');
      if (onNavigate) onNavigate(target);
    });
  });

  return container;
}
